import * as Helpers from "./Helpers"


export const def = {
    query:{
        maxWalkDistance: 750,
        time: Helpers.getTimeFromDate(Helpers.getNow()),
        date: Helpers.getDateFromDate(Helpers.getNow()), // date format: yyyy-MM-ddThh:mm
        congestionEnabled: false,
        mode: "ELECTRIC",
        chargeLevel:100,
        maxBikeDistance: 10000,
        weightOptimization: "QUICKER",
        requestedResults: 1,
        responseTimeout: 1,
        energyCost: 50,
        fuelConsumption: 8,
        fuelCost: 50,
        motorcycleFuelUsage: 6,
        motorcycleFuelCost: 50,
        motivationFrom: "",
        motivationTo: "",
        electricCarIndex: 17,
        minChargeLevel:10,
        luggageWeight:0,
        driverWeight: 80,
        responseTimeout:10,
        arriveBy:false,
    }
}
